import React, { useEffect, useState } from 'react';
import './settings.css';
import { DrugExceptionsClient } from '../../../client/drug-exceptions-client';
import { TextField } from '@mui/material';

interface HandleError {
    handleError: Function;
}

export default function AssessorSettings(props: HandleError) {
    const userId = JSON.parse(sessionStorage.getItem('userId') || 'null');
    const userIdentityObject = JSON.parse(sessionStorage.getItem('userIdentityObject') || 'null');
    const client = new DrugExceptionsClient();

    const [currentPassword, setCurrentPassword] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [password2, setPassword2] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    const passwordsMismatch = password !== '' && password2 !== '' && password !== password2;

    const changePassword = async () => {
        if (currentPassword !== '' && password !== '' && password2 !== '') {
            if (password !== password2) {
                props.handleError({
                    error: true,
                    ajax: {
                        request: {
                            responseText: ['Passwords do not match!']
                        }
                    }
                });
                return;
            }

            setLoading(true);
            try {
                const payload = {
                    oldPassword: currentPassword,
                    newPassword: password
                };

                await client.api.post('/users/changepassword', payload, {
                    headers: {
                        Authorization: `Bearer ${userId.authToken}`
                    }
                });

                props.handleError({
                    error: false,
                    ajax: {
                        request: {
                            responseText: ['Password changed successfully']
                        }
                    }
                });

                // Clear fields on success
                setCurrentPassword('');
                setPassword('');
                setPassword2('');
            } catch (error) {
                props.handleError(error);
            } finally {
                setLoading(false);
            }
        } else {
            props.handleError({
                error: true,
                ajax: {
                    request: {
                        responseText: ['Passwords cannot be empty!']
                    }
                }
            });
        }
    };

    return (
        <div className="assessor-settings-container">
            <div className="header">
                <h1>Settings</h1>
            </div>
            <div className="settings">
                <div>
                    <div className="account-details">
                        <h1>Account Details</h1>
                        <h3>{userIdentityObject.firstName} {userIdentityObject.lastName}</h3>
                        <div className="detail-group">
                            <div className="detail-label">Email:</div>
                            <div className="detail-info">{userIdentityObject.identity.email}</div>
                        </div>
                    </div>
                    <div className="change-password">
                        <h1>Change Password</h1>
                        <TextField
                            fullWidth
                            label="Enter your current password*"
                            type="password"
                            variant="filled"
                            value={currentPassword}
                            onChange={e => setCurrentPassword(e.target.value)}
                            margin="normal"
                            disabled={loading}
                        />
                        <TextField
                            fullWidth
                            label="Enter a new password*"
                            type="password"
                            variant="filled"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            error={passwordsMismatch}
                            margin="normal"
                            disabled={loading}
                        />
                        <TextField
                            fullWidth
                            label="Re-type new password*"
                            type="password"
                            variant="filled"
                            value={password2}
                            onChange={e => setPassword2(e.target.value)}
                            error={passwordsMismatch}
                            helperText={passwordsMismatch ? 'Passwords do not match' : ''}
                            margin="normal"
                            disabled={loading}
                        />
                        <div>
                            <button
                                className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped"
                                onClick={changePassword}
                                disabled={loading}
                            >
                                <div className="mdc-button__ripple"></div>
                                <span className="mdc-button__label">CHANGE PASSWORD</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
